// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Dot = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Dot = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var Dot = _exports.Dot = function Dot(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      width: "13",
      height: "13",
      viewBox: "0 0 13 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14716)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.0706 6.50014C12.0706 9.57716 9.57618 12.0716 6.49916 12.0716C3.42215 12.0716 0.927734 9.57716 0.927734 6.50014C0.927734 3.42312 3.42215 0.928711 6.49916 0.928711C9.57618 0.928711 12.0706 3.42312 12.0706 6.50014Z",
      fill: "#1E9A50"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.49916 11.143C9.06334 11.143 11.142 9.06432 11.142 6.50014C11.142 3.93596 9.06334 1.85728 6.49916 1.85728C3.93498 1.85728 1.85631 3.93596 1.85631 6.50014C1.85631 9.06432 3.93498 11.143 6.49916 11.143ZM6.49916 12.0716C9.57618 12.0716 12.0706 9.57716 12.0706 6.50014C12.0706 3.42312 9.57618 0.928711 6.49916 0.928711C3.42215 0.928711 0.927734 3.42312 0.927734 6.50014C0.927734 9.57716 3.42215 12.0716 6.49916 12.0716Z",
      fill: "white"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14716"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "13",
      height: "13",
      fill: "white"
    }))));
  };
});
